/* Full cart page — Shopify-style quantities (inputs), remove line, free-ship meter */
(() => {
  const pageRoot = document.querySelector("[data-cart-page]");
  if (!pageRoot) return;

  const formatInr = (amount) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(amount);

  const freeShipEnabled = pageRoot.getAttribute("data-free-shipping-enabled") === "true";
  const FREE_MIN = Number.parseInt(pageRoot.getAttribute("data-free-shipping-min") || "3000", 10) || 3000;
  const thresholdMoney = pageRoot.getAttribute("data-free-shipping-threshold-money") || "";
  const taxesIncluded = pageRoot.getAttribute("data-taxes-included") === "true";
  const layout = pageRoot.querySelector(".cart-page-layout");
  const pageHeader = pageRoot.querySelector(".cart-page-header");
  const emptyEl = pageRoot.querySelector("[data-cart-empty]");
  const secondary = pageRoot.querySelector("[data-cart-secondary]");

  const getLines = () => [...pageRoot.querySelectorAll("tbody [data-cart-line]")];

  const setLineBusy = (line, busy) => {
    if (!line) return;
    line.classList.toggle("is-updating", Boolean(busy));
    line.querySelectorAll("button, input").forEach((el) => {
      if (busy) el.setAttribute("disabled", "disabled");
      else el.removeAttribute("disabled");
    });
  };

  const postLineChange = async (lineIndex, quantity) => {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(lineIndex), quantity: Number(quantity) })
    });
    if (!res.ok) throw new Error("Cart update failed");
    return res.json();
  };

  const formatMoneyCents = (cents) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(
      (Number(cents) || 0) / 100
    );

  const recalcPage = () => {
    let subtotalCents = 0;
    let count = 0;
    getLines().forEach((line) => {
      const inp = line.querySelector("[data-cart-line-qty]");
      let qty = Math.max(0, Number.parseInt(String(inp?.value), 10) || 0);
      if (inp) inp.value = String(qty);
      const unitCents = Number(line.dataset.unitPrice) || 0;
      subtotalCents += unitCents * qty;
      count += qty;
      const lineTotalCents = unitCents * qty;
      const totalEl = line.querySelector("[data-cart-line-total]");
      if (totalEl) totalEl.textContent = formatMoneyCents(lineTotalCents);
    });

    const subtotalRupees = subtotalCents / 100;

    const subEl = pageRoot.querySelector("[data-cart-subtotal]");
    const taxNoteEl = pageRoot.querySelector("[data-cart-tax-note]");
    if (subEl) subEl.textContent = formatMoneyCents(subtotalCents);
    if (taxNoteEl) {
      taxNoteEl.textContent = taxesIncluded ? "Included in prices" : "Calculated at checkout";
    }

    const countEl = pageRoot.querySelector("[data-cart-page-count]");
    if (countEl) countEl.textContent = String(count);

    const msgEl = pageRoot.querySelector("[data-cart-page-free-ship-msg]");
    const bar = pageRoot.querySelector("[data-cart-free-ship-bar]");
    const lbl = pageRoot.querySelector("[data-cart-free-ship-label]");
    if (freeShipEnabled && msgEl) {
      if (subtotalRupees >= FREE_MIN) {
        msgEl.textContent =
          "You qualify for free shipping on this order (cart meets or exceeds the free-shipping minimum).";
      } else {
        const need = FREE_MIN - subtotalRupees;
        msgEl.textContent = `${formatInr(need)} away from free shipping (${thresholdMoney}+).`;
      }
    }
    if (freeShipEnabled && bar) {
      const pct = FREE_MIN <= 0 ? 100 : Math.min(100, Math.round((subtotalRupees / FREE_MIN) * 100));
      bar.style.width = `${pct}%`;
    }
    if (freeShipEnabled && lbl) {
      if (subtotalRupees >= FREE_MIN) {
        lbl.textContent = `Free shipping at ${thresholdMoney}+ — threshold reached`;
      } else {
        const pct = Math.round((subtotalRupees / FREE_MIN) * 100);
        lbl.textContent = `${pct}% toward free shipping (${thresholdMoney}+)`;
      }
    }

    document.querySelectorAll("[data-cart-badge]").forEach((badge) => {
      badge.textContent = count > 9 ? "9+" : String(count);
    });
    const toggle = document.querySelector("[data-cart-toggle]");
    if (toggle) {
      const label =
        count === 0 ? "Shopping cart, empty" : count === 1 ? "Shopping cart, 1 item" : `Shopping cart, ${count} items`;
      toggle.setAttribute("aria-label", label);
    }

    const lines = getLines();
    const allGone = lines.length === 0;
    const allZero = lines.length > 0 && lines.every((line) => (Number.parseInt(String(line.querySelector("[data-cart-line-qty]")?.value), 10) || 0) === 0);
    if (allGone || allZero) {
      if (layout) layout.hidden = true;
      if (pageHeader) pageHeader.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (secondary) secondary.hidden = true;
    } else {
      if (layout) layout.hidden = false;
      if (pageHeader) pageHeader.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (secondary) secondary.hidden = false;
    }
  };

  pageRoot.querySelectorAll("[data-cart-qty-delta]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const line = btn.closest("[data-cart-line]");
      const inp = line?.querySelector("[data-cart-line-qty]");
      if (!line || !inp) return;
      const lineIndex = Number.parseInt(line.getAttribute("data-line-index") || "0", 10);
      if (!lineIndex) return;
      let q = Number.parseInt(String(inp.value), 10) || 0;
      const delta = Number.parseInt(btn.getAttribute("data-cart-qty-delta") || "0", 10);
      q = Math.max(0, Math.min(99, q + delta));
      setLineBusy(line, true);
      try {
        await postLineChange(lineIndex, q);
        window.location.reload();
      } catch (_e) {
        setLineBusy(line, false);
      }
    });
  });

  pageRoot.querySelectorAll("[data-cart-line-qty]").forEach((inp) => {
    inp.addEventListener("input", () => recalcPage());
    inp.addEventListener("change", async () => {
      const line = inp.closest("[data-cart-line]");
      const lineIndex = Number.parseInt(line?.getAttribute("data-line-index") || "0", 10);
      if (!line || !lineIndex) return;
      const q = Math.max(0, Math.min(99, Number.parseInt(String(inp.value), 10) || 0));
      inp.value = String(q);
      setLineBusy(line, true);
      try {
        await postLineChange(lineIndex, q);
        window.location.reload();
      } catch (_e) {
        setLineBusy(line, false);
      }
    });
  });

  pageRoot.querySelectorAll("[data-cart-remove-line]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const line = btn.closest("[data-cart-line]");
      const lineIndex = Number.parseInt(line?.getAttribute("data-line-index") || "0", 10);
      if (!line || !lineIndex) return;
      setLineBusy(line, true);
      try {
        await postLineChange(lineIndex, 0);
        window.location.reload();
      } catch (_e) {
        setLineBusy(line, false);
      }
    });
  });

  document.getElementById("cart-discount-apply")?.addEventListener("click", () => {
    const code = (document.getElementById("cart-discount")?.value || "").trim();
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent("/cart")}`;
  });

  recalcPage();
})();
